module.exports = __webpack_public_path__ + "static/media/oh_pack1_sample006_0001.99e0dbb4.png";